const address = [
  "Boulevard du Jubilé 71 bte3, 1080 Brussels, Belgium",
  '<a href="mailto:colin@ecrloss.com">colin@ecrloss.com</a>',
]

export const contacts = [
  {
    title: "Main office",
    data: address,
  },
  {
    title: "ECR Community a.s.b.l",
    data: address,
  },
]
